import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "../../Apis/Axios";
import {FOODIE_MENU_SERVICE} from "../EndPoints";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

export const getAllMealtimes = createAsyncThunk(
    "foodie/getAllMealtimes",
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiInstance.get(FOODIE_MENU_SERVICE.getAllMealTimes);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export const getAppetizer = createAsyncThunk(
    "foodie/getAppetizer",
    async (body, { rejectWithValue }) => {
        try {
            const response = await apiInstance.post(`/foodie-menu-service/v1/search`, body);
            return response.data;
        } catch (error) {
            // If the server responded with a structured error
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // <- { code, message, etc. }
            }
        }
    }
);

export const saveOrder = createAsyncThunk(
    "foodie/saveOrder",
    async (body, { rejectWithValue }) => {
        try {
            const response = await apiInstance.post(`/foodie-menu-service/v2/orders/create`, body);
            return response.data;
        } catch (error) {
            // If the server responded with a structured error
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // <- { code, message, etc. }
            }
        }
    }
);


export const saveOrderForRequestMeal = createAsyncThunk(
    "foodie/saveRequestMeal",
    async (body, { rejectWithValue }) => {
        try {
            const response = await apiInstance.put(`/foodie-menu-service/v2/orders/meals`, body);
            return response.data;
        } catch (error) {
            // If the server responded with a structured error
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // <- { code, message, etc. }
            }
        }
    }
);


export const GetTotalMealsKpisList = createAsyncThunk('extraMeal/getTotalMealsKpisList ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .post(`/foodie-menu-selection-service/v1/menu-selection/total-meals-kpi`, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const GetTotalMealsKpisGrid = createAsyncThunk('extraMeal/getTotalMealsKpisGrid ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`/foodie-menu-service/v2/orders/dashboard/kpi-stats/${params?.date}/${params?.attendanceSearchType}`, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetMealTimeStats = createAsyncThunk('extraMeal/getMealTimeStats ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`/foodie-menu-service/v2/orders/dashboard/meal-time-stats/${params?.date}/${params?.attendanceSearchType}`, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
